type GtagCommand = "config" | "event" | "js" | "set";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (command: GtagCommand | string, ...args: unknown[]) => void;
  }
}

const getMeasurementId = (): string | undefined => {
  const id = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!id || typeof id !== "string") {
    return undefined;
  }
  return id;
};

const isAnalyticsEnabled = (): boolean =>
  import.meta.env.PROD && Boolean(getMeasurementId());

export const trackEvent = (
  name: string,
  params?: Record<string, string | number | boolean>
): void => {
  if (!isAnalyticsEnabled() || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", name, params);
};
